// Safe canvas utilities - prevent createRadialGradient crashes

export function safeRadius(value, fallback = 1) {
  if (value === undefined || value === null || isNaN(value) || !isFinite(value)) return fallback;
  return Math.max(0.1, value);
}

export function safeAlpha(value) {
  if (value === undefined || value === null || isNaN(value) || !isFinite(value)) return 0;
  return Math.max(0, Math.min(1, value));
}

export function safeCoord(value, fallback = 0) {
  if (value === undefined || value === null || isNaN(value) || !isFinite(value)) return fallback;
  return value;
}

export function safeGradient(ctx, cx, cy, r1, cx2, cy2, r2) {
  const sr1 = safeRadius(r1, 0.1);
  const sr2 = safeRadius(r2, 1);
  const scx = safeCoord(cx);
  const scy = safeCoord(cy);
  const scx2 = safeCoord(cx2, scx);
  const scy2 = safeCoord(cy2, scy);
  try {
    return ctx.createRadialGradient(scx, scy, sr1, scx2, scy2, Math.max(sr1 + 0.1, sr2));
  } catch {
    // Fallback: simple fill
    const g = ctx.createRadialGradient(scx, scy, 0.1, scx2, scy2, 10);
    g.addColorStop(0, 'rgba(40,160,255,0.1)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    return g;
  }
}

export function safeDraw(ctx, drawFn) {
  try {
    drawFn();
  } catch {
    // Silent fail - skip frame
  }
}

export function debounce(fn, ms) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}
